$(document).on('turbo:load', function() {
  $("#accordion_sidebar .js-submenu-wrapper .nav-link.active").closest(".accordion-item").children(".accordion-button").removeClass("collapsed");
  $("#accordion_sidebar .js-submenu-wrapper .nav-link.active").closest(".collapse").addClass("show");
});
